const AES_KEY = import.meta.env.VITE_AES_KEY
const AES_IV = "3c7e1a9d5b2f8046"

function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }

  return bytes.buffer
}

export async function decryptUserId(encryptedUserId: string): Promise<string> {
  if (!encryptedUserId) return ""

  try {
    const keyBytes = new TextEncoder().encode(AES_KEY)
    const ivBytes = new TextEncoder().encode(AES_IV)

    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-CBC" },
      false,
      ["decrypt"],
    )

    const plainBuffer = await crypto.subtle.decrypt(
      { name: "AES-CBC", iv: ivBytes },
      cryptoKey,
      base64ToArrayBuffer(encryptedUserId),
    )

    return new TextDecoder().decode(plainBuffer)
  } catch {
    return encryptedUserId
  }
}
